export const AccessCodeFlow = Object.freeze({
  PASSWORDLESS_SIGN_IN: 'PASSWORDLESS_SIGN_IN',
  SELECT_CLAIM_SIGN_IN: 'SELECT_CLAIM_SIGN_IN',
  SIGN_UP: 'SIGN_UP',
})
